import { DocumentReference } from './document-reference';
import { Document } from './document';
import { NameIntValue } from './name-int-value';

export class ServiceYearMember extends Document {
    id?: string;
    
    member: DocumentReference;

    church: DocumentReference;

    ageGroup: DocumentReference; // 4-6
    yearLevel: DocumentReference; // Grade 4
    gender: NameIntValue;
    
    spiritual: boolean;

    // TODO: Replace with lists
    choir: boolean;
    drama: boolean;
    it: boolean;
    media: boolean;
    visualArt: boolean;
    
    notes: string;

    serviceYear: string;
    
    choirList: DocumentReference[] = [];
    theatreList: DocumentReference[] = [];
    mediaList: DocumentReference[] = [];
    itList: DocumentReference[] = [];

    sportList: DocumentReference[] = [];
}
